import React from 'react';
import { useTranslation } from 'react-i18next';
import { COLLECT_STATUS_CONFIG } from '../../constants';
import { CollectCounts, CollectStatus } from '../../types';
import * as Styled from './CollectProgress.styles';

interface CollectProgressProps {
  counts: CollectCounts;
  statusCounts: Record<CollectStatus, number>;
}

const CollectProgress = ({ counts, statusCounts }: CollectProgressProps) => {
  const { t } = useTranslation();
  const percent = counts.all > 0 ? (counts.done / counts.all) * 100 : 0;

  return (
    <Styled.ProgressContainer>
      <div className="progress-header">
        <span>{t('OrderPage.Collect.PROGRESS')}</span>
        <span className="progress-count">
          {counts.done} / {counts.all}
        </span>
      </div>
      <Styled.ProgressTrack>
        <Styled.ProgressFill
          percent={percent}
          isDone={counts.done === counts.all}
        />
      </Styled.ProgressTrack>
      <Styled.StatusChips>
        {Object.values(CollectStatus).map((status) => {
          const count = statusCounts[status];
          return (
            <span
              key={status}
              className={`chip ${count > 0 ? 'active' : ''}`}
              style={
                count > 0
                  ? { color: COLLECT_STATUS_CONFIG[status].color }
                  : undefined
              }
            >
              <span className="chip-icon">
                {COLLECT_STATUS_CONFIG[status].icon}
              </span>
              {count}
            </span>
          );
        })}
      </Styled.StatusChips>
    </Styled.ProgressContainer>
  );
};

export default CollectProgress;
